<div class="flex justify-end">
  <app-close-chip (closed)="dialogRef.close()"/>
</div>
<h2 mat-dialog-title>{{ titleKey | translate }}</h2>
<div class="flex flex-col items-center justify-between flex-grow p-2">
    <div mat-dialog-content class="flex items-center justify-center p-4">

        <!-- Loading State -->
        <div *ngIf="loadingCamera" class="flex flex-col items-center justify-center py-8 px-4 text-center">
            <mat-spinner diameter="40" class=""></mat-spinner>
            <p class="text-default-gray text-sm text-center">
                {{ 'components.take_picture.starting_camera' | translate }}
            </p>
            <p class="text-light-gray text-xs text-center mt-2">
                {{ 'components.take_picture.camera_permission_hint' | translate }}
            </p>
        </div>

        <!-- Error State -->
        <div *ngIf="cameraError" class="flex flex-col items-center justify-center py-8 px-4 text-center">
            <mat-icon svgIcon="ph-regular-camera-slash" class="icon-xl text-error"></mat-icon>
            <h3 class="text-default-gray text-lg font-semibold mb-2 text-center">
                {{ 'components.take_picture.camera_error_title' | translate }}
            </h3>
            <p class="text-light-gray text-sm text-center">
                {{ 'components.take_picture.camera_error_hint' | translate }}
            </p>
            <button mat-raised-button color="primary" (click)="retryCamera()" class="w-full">
                <mat-icon svgIcon="ph-regular-arrows-clockwise"></mat-icon>
                {{ 'components.take_picture.retry' | translate }}
            </button>
        </div>

        <!-- Camera State -->
        <div [hidden]="!camera || loadingCamera || cameraError" class="flex flex-col items-center w-full">
            <div class="w-full">
                <video #videoElement [srcObject]="camera" autoplay playsinline muted
                    class="w-full h-[260px] rounded-lg bg-black object-cover">
                </video>
                <canvas #canvasElement class="hidden"></canvas>
            </div>
        </div>
    </div>

    <!-- Botón Cancelar siempre visible -->
    <div class="w-full flex flex-col gap-2">
        <button *ngIf="!!camera && !cameraError && !loadingCamera" mat-raised-button color="accent"
            (click)="takePicture()" class="w-full">
            <mat-icon svgIcon="ph-regular-camera"></mat-icon>
            {{ 'components.take_picture.take_photo' | translate }}
        </button>
        <ng-container *ngIf="allowGallery">
            <input hidden #galleryInput type="file" [attr.accept]="fileAccept" (change)="onGallerySelected($event)">
            <button mat-stroked-button color="primary" (click)="galleryInput.click()" class="w-full">
                <mat-icon [svgIcon]="galleryButtonIcon"></mat-icon>
                {{ galleryButtonKey | translate }}
            </button>
        </ng-container>
    </div>
</div>
